import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { makeRequest } from "../apis/makeRequest";
import { getProducts } from "../apis/backendRequests";
import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { ProductBody } from "../components/ProductTableSeller";
import ProductCardCatalogo from "../components/Catalogo/ProductCardCatalogo";

const size = (l) => {
  switch (l) {
    case 1:
      return 10;
    case 2:
      return 5;
    case 3:
      return 4;
    default:
      return 3;
  }
};

export default function Home() {
  const { searchTerm, categoria, rubro, subRubro, promocion } = useSelector(
    (state) => state.gallery
  );
  const { items } = useSelector((state) => state.cart);

  const account = useSelector((state) => state.account);

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const lastItemRef = useRef()

  useEffect(() => {
    setPage(1);
  }, [searchTerm, categoria, rubro, subRubro, promocion]);

  useEffect(() => {

    localStorage.setItem("cartItems", JSON.stringify(items));
    localStorage.setItem("orderItems", []);
  }, [items]);

  useEffect(() => {
    let rowsPerPage = Object.keys(account.salesData).length !== 0 ? 35 : 10
    makeRequest(
      () =>
        getProducts(
          account.dynamicsId,
          1,
          rowsPerPage * page,
          searchTerm,
          categoria,
          rubro,
          subRubro,
          promocion
        ),
      (res) => setProducts(res.data)
    );
  }, [account.dynamicsId, account.salesData, searchTerm, categoria, rubro, subRubro, page, promocion]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && entries[0].time > 2000) {
          setPage(page + 1);
        }
      },
      { threshold: 0.9 }
    );

    const current = lastItemRef.current;

    if (current) observer.observe(current);

    return () => observer.disconnect(current);
  });

  const productGrid = products.map((product, i) => {
    return (
      <Grid
        item
        md={size(products.length)}
        key={product.productId}
        ref={i === 10 * page - 1 ? lastItemRef : null}
      >
        <ProductCardCatalogo product={product} isClient={true} />
      </Grid>
    );
  });

  const ProductTable = () => {
    return (
      <Table stickyHeader sx={{ width: "80%" }} size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Descripción</TableCell>
            <TableCell align="center">Item</TableCell>
            <TableCell align="center">Precio de lista</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((product, i) => (
            <TableRow key={product.productId} ref={i === 35 * page - 1 ? lastItemRef : null} sx={{
              '&:hover': {
                backgroundColor: '#f2f2f2',
              },
            }}>
              <ProductBody product={product} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  if (Object.keys(account.salesData).length !== 0) {
    return (
      <ProductTable />
    )
  }

  return (
    <div>
      <Grid spacing={2} container sx={{ display: "flex" }}>
        {products.length > 0 ? productGrid : <Box width={"60vw"} />}
      </Grid>
    </div>
  );
}
